import { Box, Header, Icon } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const StyledBackIcon = Icon.withConfig({
  color: theme.token('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export const PanelContainer = Box.withConfig({
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  _ios: { marginTop: '$12' },
  _android: { marginTop: '$3' },
  marginTop: 0,
});

export const StyledHeader = Header.withConfig({
  position: 'absolute',
  textAlign: 'center',
  left: 0,
  right: 0,
  margin: 0,
  variant: 'headerTwo',
});
